module.exports = __webpack_public_path__ + "img/brand-ud.a5897127.png";